// components/TimezoneInitializer.tsx
import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { getHomepageRuntimeConfig } from '../../sitePublishing/publicConfigSource';
import { resetDefaultTimezone, setDefaultTimezone } from '../../utils/dayjs-config';
import { useOptionalTenant } from '../../tenancy/TenantContext';
import { shouldUseOperationalTimezone } from '../../tenancy/timezoneSource';
import { getOperationalTenantTimezone } from '../../tenancy/tenantTimezoneRepository';

const TimezoneInitializer = () => {
  const tenantId = useOptionalTenant()?.tenantId;
  const { user } = useAuth();
  const location = useLocation();
  const isAdminPath = location.pathname === '/admin' || location.pathname.startsWith('/admin/');
  const useOperationalTimezone = shouldUseOperationalTimezone(location.pathname, Boolean(user));
  const publicConfigQuery = useQuery({
    queryKey: ['publicBusinessConfig', tenantId],
    queryFn: () => getHomepageRuntimeConfig(tenantId!),
    enabled: Boolean(tenantId) && !useOperationalTimezone && !isAdminPath,
  });
  const operationalTimezoneQuery = useQuery({
    queryKey: ['operationalTimezone', tenantId],
    queryFn: () => getOperationalTenantTimezone(tenantId!),
    enabled: Boolean(tenantId) && useOperationalTimezone,
  });
  const timezone = useOperationalTimezone
    ? operationalTimezoneQuery.data
    : publicConfigQuery.data?.businessInfo?.timezone;

  useEffect(() => {
    resetDefaultTimezone();
  }, [tenantId, useOperationalTimezone]);

  useEffect(() => {
    if (timezone) {
      setDefaultTimezone(timezone);
    }
  }, [timezone]);

  return null; // This component does not render anything visible
};

export default TimezoneInitializer;
